import React from "react";
import Testimonials from "../home/Testimonials";

const LinkedinTestimonials = () => {
  return <Testimonials />;
};

export default LinkedinTestimonials;
